import { useState, useEffect } from 'react';
import { usersGraphqlService } from '@/services/api/users/usersGraphqlService';
import { useAuth } from '@/contexts/AuthContext';

export interface UserGroupDropdownItem {
  user_group_id: number;
  user_group_name: string;
  user_count: number;
  created_datetime: string;
  updated_datetime: string;
}

export interface UseUserGroupsListResult {
  userGroups: UserGroupDropdownItem[];
  loading: boolean;
  error: string | null;
}

export const useUserGroupsList = (): UseUserGroupsListResult => {
  const { hasuraToken } = useAuth();
  const [userGroups, setUserGroups] = useState<UserGroupDropdownItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserGroups = async () => {
      if (!hasuraToken) {
        setError('Authentication required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await usersGraphqlService.getAllUserGroupsForDropdown(hasuraToken);

        if (response.success && response.data) {
          setUserGroups(response.data.pep_vw_user_group_dashboard);
          setError(null);
        } else {
          setError('Failed to fetch user groups');
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch user groups');
      } finally {
        setLoading(false);
      }
    };

    fetchUserGroups();
  }, [hasuraToken]);

  return {
    userGroups,
    loading,
    error
  };
};
